class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-details-modal-toggle]');
    this._dialog = this.querySelector('dialog');

    this.toggle.addEventListener('click', this.onToggleClick.bind(this));
    this.querySelector('button[type="button"]:not([data-details-modal-toggle])').addEventListener('click', () =>
      this.close()
    );

    this.toggle.setAttribute('role', 'button');

    // Focus trap/return and Escape-to-close now come from the native <dialog> via showModal()/close().
    this._dialog?.addEventListener('close', this.onDialogClose.bind(this));
    this._dialog?.addEventListener('click', (event) => {
      if (event.target === this._dialog) this.close();
    });

    // BEGIN CUSTOM
    this.header = this.closest('.header-wrapper');
    // END CUSTOM
  }

  isOpen() {
    return this._dialog?.open ?? false;
  }

  onToggleClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    if (!this._dialog) return;
    this.toggle.setAttribute('aria-expanded', true);
    this._dialog.showModal();
    document.body.classList.add('overflow-hidden');

    // BEGIN CUSTOM
    if (this.header) {
      this.header.classList.add('is-header-menu-open');
      document.body.classList.add('is-header-menu-open');
    } // END CUSTOM
  }

  close(focusToggle = true) {
    if (!this._dialog) return;
    this._dialog.close();
    if (!focusToggle && document.activeElement === this.toggle) this.toggle.blur();
  }

  onDialogClose() {
    this.toggle.setAttribute('aria-expanded', false);
    document.body.classList.remove('overflow-hidden');

    // BEGIN CUSTOM
    if (this.header) {
      this.header.classList.remove('is-header-menu-open');
      document.body.classList.remove('is-header-menu-open');
    } // END CUSTOM
  }
}

customElements.define('details-modal', DetailsModal);
